const urlBase = {
  loopBack: "https://hml.dentalcenterpb.com.br/api/",
  client: "https://hml.dentalcenterpb.com.br/",
  version: "2.6.0",
};
export default urlBase;



/** WEBPACK FOOTER **
 ** ./src/url-base.js
 **/